import React from 'react';
import PropTypes from 'prop-types';
import Wrapper from '../../common/component/Wrapper';
import Dropdown from '../../common/component/Dropdown';
import Ripple from '../../common/component/Ripple';
import { Icon, Popover, Tooltip } from 'antd';
import { TRANSLATE_LANGUAGE, TICKET, ORDER, DATE_TIME_FORMAT } from '../../../../constants/Define';
import Images from '../../../../constants/Images';

import { omit, find, toArray, groupBy } from 'lodash';
import './MyTicketBoard.less';
import { LocalStorage } from '../../../../utils';
import TicketBoard from '../../common/component/TicketBoard';
import { dummyTickets } from '../../../../constants/Dummies';
import Ticket from '../../../../models/Ticket';
import Span from '../../common/component/Span';
import FontIcon, { SolidIcons } from '../../common/component/FontIcon';
import EllipsisText from '../../common/component/EllipsisText';

const ticketEnumData = dummyTickets.map(item => new Ticket(item))

export default class MyTicketBoard extends React.PureComponent {

    constructor(props) {
        super(props);
        this.state = {
        };
    }

    componentDidUpdate(prevProps) {

    }

    componentDidMount() {
    }

    render() {
        const { t, tickets, draggable, editable, hideCardDeleteIcon } = this.props;
        const data = this.getTicketData(tickets)
        return (
            <Wrapper className="my-ticket-board">
                <TicketBoard
                    data={data}
                    draggable={draggable}
                    editable={editable}
                    hideCardDeleteIcon={hideCardDeleteIcon}
                    onCardClick={this.onCardClick}
                />
            </Wrapper>
        )
    }

    getTicketData = (tickets = []) => {
        const { t, draggable, editable } = this.props;
        const groupedTickets = groupBy(tickets, 'status');
        const groupedKeys = Object.keys(groupedTickets);
        const lanesColumns = toArray(TICKET.STATUS).filter(item => !item.hide)
        return {
            lanes: lanesColumns.map(statusEnum => {
                if (statusEnum) {
                    return {
                        id: statusEnum.key,
                        title: t(`item.ticket.statusTypes.${statusEnum.key}`),
                        label: groupedTickets[statusEnum.id] ? String(groupedTickets[statusEnum.id].length) : '0',
                        style: { color: statusEnum.color },
                        cards: (groupedTickets[statusEnum.id] || []).map(ticketItem => ({
                            id: ticketItem.id,
                            title: this.renderTicketHeader(ticketItem),
                            label: this.renderTicketOrderType(ticketItem),
                            description: this.renderTicketDescription(ticketItem),
                            draggable, editable,
                            metadata: ticketItem,
                        })),
                    }
                }
            })
        };
    }

    renderTicketHeader(ticket) {
        return (
            <Wrapper>
                <Span>{ticket.orderCode}</Span>
            </Wrapper>
        )
    }

    renderTicketOrderType = (ticket) => {
        const typeKey = find(Object.keys(ORDER.TYPES), k => ORDER.TYPES[k].id === ticket.orderItemType)

        return (typeKey &&
            <Tooltip key={typeKey} title={this.props.t(`item.order.orderTypes.${typeKey.toLowerCase()}`)}>
                <Span className="ml-2">
                    <FontIcon key={ORDER.TYPES[typeKey].id} color={ORDER.TYPES[typeKey].color}
                        icon={SolidIcons[ORDER.TYPES[typeKey].icon]} size="sm" />
                </Span>
            </Tooltip>
        )
    }

    renderTicketDescription = (ticket) => {
        const { t } = this.props;
        return (
            <Wrapper className="ticket-description">
                <EllipsisText
                    title={ticket.ticketName}
                    content={ticket.ticketName}
                    className="ticket-name"
                    contentMaxWidth={230}
                    overlayClassName={'max-width-500'}
                    />
                <EllipsisText
                    title={t('item.ticket.notes')}
                    content={ticket.notes}
                    className="ticket-notes"
                    contentMaxWidth={230}
                    overlayClassName={'max-width-500'}
                    overlayComponent={Popover}
                    />
            </Wrapper>
        )
    }

    onCardClick = (cardId, metadata, laneId) => {
        this.props.onClickTicket(metadata, cardId, laneId)
    }


}
MyTicketBoard.propTypes = {
    onClickTicket: PropTypes.func,
    tickets: PropTypes.array,
    draggable: PropTypes.bool,
    editable: PropTypes.bool,
    hideCardDeleteIcon: PropTypes.bool,
}
MyTicketBoard.defaultProps = {
    onClickTicket: (ticket, ticketId, laneId) => { },
    tickets: [],
    draggable: false,
    editable: false,
    hideCardDeleteIcon: true,
}